import c from './landing-questions-screen';
import './landing-questions-screen.sass';

export default c;
